import { ErrorResponseErrorItemCodeTag } from '../../../../typings/api/skymap/rest/v1/.common';

export const translations: Record<ErrorResponseErrorItemCodeTag, string> = {
  'tag:tags_not_found': 'Taggar existerar inte.',
};
